import axios from 'axios'//引入axios
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import { API_URL } from '@/utils/url'
import store from '@/store/index'

//创建axios实列
const instance = axios.create({
    baseURL: API_URL,
    timeout: 10000 //超时时间
})


//请求拦截器
instance.interceptors.request.use(
    config => {
        let token = localStorage.getItem('user-token');
        if (token) {
            config.headers['user-token'] = token;//请求头中设置x-authtotal
        }
        // console.log("请求拦截器中", config);
        return config;//参数请求的数据
    },
    error => {

    }
)
//响应拦截器
let sum = 0

instance.interceptors.response.use(
    success => {
        if (success.data.code === 1000) {
            console.log(sum)
            if (sum === 0) {
                sum += 1




                MessageBox.alert('请先登录', '无法访问', {
                    confirmButtonText: '确定',
                    type: 'warning',
                    callback: action => {
                        store.state.redirectUrl = window.location.pathname //获取url路径

                        store.state.isShowLoginBox = true

                        sum = 0

                    }
                });

            }



        }
        if (success.data.code === 1001) {
          
            if (sum === 0) {
                sum += 1
                if(!store.state.isShowLoginExpiredBox){
                    return;
                }
                store.state.isShowLoginExpiredBox=false;

                store.state.isServerReconnection=false;

                MessageBox.confirm('登录已失效', '系统提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    localStorage.removeItem("user-token");
                    localStorage.removeItem("user-id");
                    localStorage.removeItem("user-img");
                    localStorage.removeItem("user-nickname");
                    localStorage.removeItem("user-fillState");

                    store.state.redirectUrl = window.location.pathname;
                    store.state.isShowLoginBox = true;
                    store.state.isShowTopBarNoLoginBox = true;
                    sum = 0;
                    store.state.isServerReconnection=true;
                    store.state.isShowLoginExpiredBox=true;

                }).catch(() => {
                    sum = 0;
                    store.state.isServerReconnection=true;
                    store.state.isShowLoginExpiredBox=true;

                });
            }
        }


        return success.data;
    },
    error => {
        console.log(error)
        return { code: 101, msg: error.message }

    }
)

export default instance